import React, { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { Link, useParams } from 'react-router-dom';
/* import { useSnackbar } from 'material-ui-snackbar-provider'; */
import { Container, styled } from '@mui/system';
import {
  Button, Grid, Paper, Typography,
} from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { getInviteGql } from '../InviteResponse/gql';
import RsvpHeading from '../../Components/RsvpHeading';

const PaperBox = styled(Paper)({
  padding: '36px 36px 36px 36px',
  paddingBottom: 10,
  position: 'relative',
});

const ErrorTypo = styled(Typography)({
  textAlign: 'center',
  marginTop: '35vh',
});

export default function Error() {
  const { inviteCode, path } = useParams();
  /* const snackbar = useSnackbar(); */
  const {
    data,
  } = useQuery(getInviteGql, {
    fetchPolicy: 'no-cache',
    variables: {
      inviteCode,
    },
    /* onError: () => snackbar.showMessage('Fehler beim laden.'), */
  });

  const invite = useMemo(() => data?.getInvite, [data?.getInvite]);

  if (!inviteCode || !invite) return (<ErrorTypo variant="h2">Fehlerhafter Link</ErrorTypo>);

  return (
    <Container maxWidth="lg">
      <RsvpHeading />
      <PaperBox sx={{ pb: 4, mb: 2 }} elevation={4}>
        <Grid container direction="row" justifyContent="center" sx={{ mb: 2 }}>
          <ErrorOutlineIcon color="error" sx={{ fontSize: 80 }} />
        </Grid>
        <Typography sx={{ textAlign: 'center', mb: 2 }} variant="h4">
          Ein Fehler ist aufgetretten
        </Typography>
        <Typography sx={{ textAlign: 'center' }}>
          Bitte versuchen Sie es erneut!
        </Typography>
        <Grid container direction="row" justifyContent="center" sx={{ pt: 4 }}>
          <Button
            variant="outlined"
            to={`/${path}/${inviteCode}/response`}
            component={Link}
          >
            Erneut versuchen
          </Button>
        </Grid>
      </PaperBox>
    </Container>
  );
}
